<template>
  <section>
      <div class="content-header">
        <h2>Videos</h2>
      </div>
      <div class="content-wrapper">
        <ul>
          <li class="pb-3"><a href="https://www.youtube.com/watch?v=otR9HkrFcEw" target="_blank">Academic Buoyancy by The Science of Self by Peter Hollins</a> </li>
          <li><a href="https://www.youtube.com/watch?v=Kpfwsd9CJ4c" target="_blank">Academic Resilience Series Featuring Lisa House, PH.D. by Millersville University</a> </li>
        </ul>
      </div>
  </section>
</template>

<script>
// import Accordion from '../components/Accordion.vue'
// import SidebarMenu from '../components/SidebarMenu.vue'
// import {
//   Hooper,
//   Slide,
//   Navigation as HooperNavigation,
//   Pagination as HooperPagination
// } from 'hooper'
// import 'hooper/dist/hooper.css'

export default {
  name: '04',
  components: {
    // SidebarMenu,
    // Accordion,
    // Hooper,
    // Slide,
    // HooperNavigation,
    // HooperPagination
  },
  data () {
    return {
    }
  },

  mounted () {
  }
}
</script>

<style>

</style>
